import { classes } from 'html-classes';
import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

import CategoryBlockTitle from '~/components/CategoryBlocks/CategoryBlockTitle';
import {
  cfSrcForImage,
  createCategoryUrl,
} from '~/components/CategoryBlocks/utils';
import CommonCarousel from '~/components/CommonCarousel/CommonCarousel';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import { useGlobal } from '~/hooks/useGlobal';

import styles from './CategoriesCarouselCircleBlock.module.scss';
import type { CategoriesCarouselCircleBlockProps } from './interfaces';

const CIRCLE_SIZE = 120;

const CategoriesCarouselCircleBlock = (
  props: CategoriesCarouselCircleBlockProps,
) => {
  const { className, category } = props;
  const { handleClickCategory } = useCategoryAnalytics();
  const { isMobile } = useGlobal();

  if (!category.subcategory.length || !category.subcategory[0]?.id) {
    return null;
  }

  return (
    <div
      className={classes([styles.root, className])}
      style={
        {
          '--circle-size': `${CIRCLE_SIZE}px`,
        } as CSSProperties
      }
    >
      <CategoryBlockTitle text={category.name} categoryId={category.id} />

      <CommonCarousel
        sliderClassName={styles.slider}
        slideClassName={styles.slide}
        rightArrowClassName={styles.rightArrow}
        leftArrowClassName={styles.leftArrow}
        spaceBetween={isMobile ? 12 : 35}
        slidesPerViewProp="auto"
        freeMode={isMobile}
      >
        {category.subcategory.map(({ id, previewImage, previewText, name }) => (
          <Link
            onClick={handleClickCategory(id)}
            to={createCategoryUrl({ id })}
            className={styles.link}
            key={id}
          >
            <div className={styles.item}>
              {previewImage ? (
                <img
                  src={cfSrcForImage(previewImage, {
                    width: CIRCLE_SIZE,
                    height: CIRCLE_SIZE,
                  })}
                  alt=""
                />
              ) : (
                <div className={styles.emptyImg} />
              )}
            </div>
            <div className={styles.itemTitle}>{previewText || name}</div>
          </Link>
        ))}
      </CommonCarousel>
    </div>
  );
};

export default CategoriesCarouselCircleBlock;
